export const faxPattern = /^\d{10}$/;

export const formatFax = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 10); // only 10 digits
  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 10);

  let formatted = '';
  if (part1) formatted = part1;
  if (part2) formatted += ' ' + part2;
  if (part3) formatted += ' ' + part3;

  return formatted;
};